import { styled } from '@material-ui/core';

export const ErrorMessage = styled('p')(({ theme: { palette } }) => ({
  color: palette.red.main,
  padding: '0px 15px',
  margin: '0',
  fontWeight: 400,
}));
